import { useCallback, useEffect } from 'react';

import { useLoadDataRequest } from '@futrli/shared-services';

import { ASSUMPTION_URL_NAME } from '../../../../core/constants';
import { fetchAssumption } from '../../../../core/api/assumption';
import { AllowedAssumptionTypes } from '../../../detail/reports/actions/actions';

type RequestDataType = Awaited<ReturnType<typeof fetchAssumption<AllowedAssumptionTypes>>>

/**
 * Loads the data for the given prediction id/type
 * @param workspaceId - Workspace ID for the organisation
 * @param organisationId - Organisation ID
 * @param forecastId - Forecast ID
 * @param predictionId - Prediction ID
 * @param predictionType - Prediction type (from the URL)
 */
export const useLoadPredictionData = (
  workspaceId: string,
  organisationId: string,
  forecastId: string | undefined,
  predictionId: string | undefined,
  predictionType: string | undefined
) => {
  const hasAllParams = !!workspaceId && !!organisationId && !!forecastId && !!predictionId && !!predictionType;
  const {load, ...rest} = useLoadDataRequest<RequestDataType>();

  const reload = useCallback(async () => {
    if (hasAllParams) {
      load(fetchAssumption<AllowedAssumptionTypes>(
        workspaceId,
        organisationId,
        forecastId,
        ASSUMPTION_URL_NAME[predictionType],
        predictionId
      ));
    }
  }, [forecastId, hasAllParams, load, organisationId, predictionId, predictionType, workspaceId])

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    hasAllParams,
    reload,
    ...rest
  };
};
